(function () {
  function openMainMenuMobile() {
    var self = this;
    this.isOpen = false;
    this.mainmenunavigator = $('#main-menu-navigator');
    this.headerMenu = $('.header-menu');
    this.annuncemntBar = $('#shopify-section-announcement-bar');
    this.menuLink = $('.main_menu_link .linktoactive');
    this.mobileBackmenu = $('.back-to-main-menu');
    this.init = function () {
      this.openMobileMenu();
      this.observerWindow();
    };

    //change menu structure to mobile menu
    this.openMobileMenu = function () {
      this.isOpen = true;
      this.mainmenunavigator.removeClass('laptop:hide');
      this.mainmenunavigator.addClass('mobile_wrap');
      this.annuncemntBar.addClass('hide');

      $('.close_mobile_menu').removeClass('hidden');

      // if search is open
      $('#search-header-container').removeAttr('open');
      $('.act_search').hide();

      // closing arrows
      $('.arrow__first-level').removeClass('open');
      $('.arrow__second-level').removeClass('open');
      $('.menu_link_item').attr('aria-expanded', 'false');

      //close second level menu items
      $('.second__level__sub-menus').addClass('hidden');

      //close third level menu items
      $('.third__level__sub-menus').addClass('hidden');

      $('body').addClass('overflow-hidden');

      this.mainLinkNavigator();

      //close mobile menu
      $('#close_mobile_menu').click(function () {
        // $('.close_mobile_menu .close_mobile').click(function(){
        console.log('close menu mobile');
        self.closeMobileMenu();
      });
      $('.close_mobile_menu_inside').click(function () {
        $('.header-menu .submenu-wrap').addClass('hide');
        $('#close_mobile_menu').click();
      });
    };

    //actions close mobile menu
    this.closeMobileMenu = function () {
      this.isOpen = false;
      this.headerMenu.removeClass('open');
      this.mainmenunavigator.addClass('laptop:hide');
      this.mainmenunavigator.removeClass('mobile_wrap');
      this.annuncemntBar.removeClass('hide');

      $('.close_mobile_menu').addClass('hidden');

      //if search is open
      $('#search-header-container').removeAttr('open');
      $('.act_search').show();

      //close submenus
      $('.second__level__sub-menus ').addClass('hidden');
      $('.third__level__sub-menus').addClass('hidden');
      $('.menu_link_item').attr('aria-expanded', 'false');

      $('body').removeClass('overflow-hidden');
    };

    //navigatorMobileMenu
    this.mainLinkNavigator = function () {
      var self = this;
      this.menuLink.click(function (e) {
        var mainLinkHaveChild = this.dataset.childblock;
        var submenusector = $('#' + mainLinkHaveChild);
        if (self.checkIfExist(submenusector)) {
          e.preventDefault();
          self.headerMenu.addClass('open');
          submenusector.removeClass('hide');

          self.openLvl3MobileMenu(submenusector);
          self.mobileMenuBack(submenusector);
        }
      });
    };

    this.mobileMenuBack = function (mobileSector) {
      var self = this;
      this.mobileBackmenu.click(function () {
        self.headerMenu.removeClass('open');
        mobileSector.addClass('hide');
      });
    };

    this.openLvl3MobileMenu = function (mobileSector) {
      mobileSector.find('.mobile_submenu_action').click(function () {
        var lvl3toOpenChild = this.dataset.child;
        if ($(this).hasClass('current')) {
          $(this).removeClass('current');
          mobileSector.find('.linktoactive').each(function () {
            $(this).addClass('hide');
          });
        } else {
          $(this).addClass('current');
          mobileSector.find('.linktoactive').each(function () {
            var tempParent = this.dataset.parent;
            if (lvl3toOpenChild === tempParent) {
              $(this).removeClass('hide');
            }
          });
        }

        return false;
      });
    };

    this.checkIfExist = function (submenu) {
      if (submenu[0]) {
        return true;
      }
      return false;
    };

    //observer on window resize
    // if change to mobile on desktop when menu mobile is open - close all
    this.observerWindow = function () {
      if (this.isOpen) {
        $(window).resize(function () {
          if ($(window).outerWidth(true) > 1375) {
            self.closeMobileMenu();
          }
        });
      }
    };
  }

  /*$( '.main_menu_link' ).click(function(e){
        new hoverMainMenu().init(this,e);
    });*/

  //Open mobile main menu
  $('#menu_mobile').click(function () {
    new openMainMenuMobile().init();
    return false;
  });
})();
